import { Flex, Grid } from '@chakra-ui/react'

import LatestAnalysis from './LatestAnalysis'
import LatestAlerts from './LatestAlerts'
import LatestMedia from './LatestMedia'
import UpsellBanner from '../common/UpsellBanner'

const LatestAnalysisNews = ({ disease = 'Mpox' }) => {
  return (
    <Flex gap={4} flexDir='column'>
      <Flex>
        <LatestAnalysis disease={disease} />
      </Flex>
      <Grid gap={4} templateColumns='1fr 1fr'>
        <LatestAlerts disease={disease} />
        <LatestMedia disease={disease} />
      </Grid>
      <UpsellBanner />
    </Flex>
  )
}

export default LatestAnalysisNews
